// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner {
    width: 40px;
    height: 40px;
    position: relative;
    margin: 40px auto;
  }
  
  .spinner-tick {
    position: absolute;
    width: 8%;
    height: 20%;
    background: #999; /* neutral gray, visible on both white and black */
    border-radius: 50px;
    top: 10%;
    left: 46%;
    opacity: 0.2;
    animation: fade 1s linear infinite;
  }
  
  @keyframes fade {
    0%   { opacity: 1; }
    100% { opacity: 0.2; }
  }

.spinner.mini-spinner {
  width: 20px;
  height: 20px;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/Spinner.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB,EAAE,kDAAkD;IACpE,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,kCAAkC;EACpC;;EAEA;IACE,OAAO,UAAU,EAAE;IACnB,OAAO,YAAY,EAAE;EACvB;;AAEF;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX","sourcesContent":[".spinner {\n    width: 40px;\n    height: 40px;\n    position: relative;\n    margin: 40px auto;\n  }\n  \n  .spinner-tick {\n    position: absolute;\n    width: 8%;\n    height: 20%;\n    background: #999; /* neutral gray, visible on both white and black */\n    border-radius: 50px;\n    top: 10%;\n    left: 46%;\n    opacity: 0.2;\n    animation: fade 1s linear infinite;\n  }\n  \n  @keyframes fade {\n    0%   { opacity: 1; }\n    100% { opacity: 0.2; }\n  }\n\n.spinner.mini-spinner {\n  width: 20px;\n  height: 20px;\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
